
<div class="row">

  <form *ngIf="formResetToggle" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>
    
    <!-- general form elements disabled -->
    <div class="row">
      <div class="col-sm-4">
        <div class="form-check mb-3">
          <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

          <label for="acceptTerms" class="form-check-label">US</label><br />
          <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
          <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
          <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
        </div>
      </div>
      <div class="col-sm-4">

      </div>
      <!--<div class="col-md-4 pull-right">

        <button *ngIf="isHJbtn" type="button" (click)="openHJPortal()" class="btn mb-3 btn-warning float-right">
          Hub Login- Hj Portal

        </button>

      </div>-->



    </div>


    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">Legal Information</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div> 
      </div>
      <!-- /.card-header -->
      <div class="card-body">


        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">

              <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Full Legal Company Name <code>*</code></label>
              <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                     placeholder="Enter Full Legal Company Name"
                     appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">

              <label class="col-form-label  col-md-12" for="login-Owner_Preferred_First_Name">Preferred First Name</label>
              <input type="text" formControlName="Owner_Preferred_First_Name" class="form-control"
                     placeholder="Enter Preferred First Name"
                     appAiHint="Owner Preferred First Name" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Preferred_First_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Preferred_First_Name.errors.required"> Name is required</div>
              </div>
            </div>
          </div>
          <div class="col-sm-4" >
            <div class="form-group">

              <label class="col-form-label  col-md-12" for="login-Owner_Preferred_Last_Name">Preferred Last Name <code>*</code></label>
              <input type="text" formControlName="Owner_Preferred_Last_Name" class="form-control"
                     placeholder="Enter Preferred Last Name"
                     appAiHint="Owner Preferred Last Name" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Preferred_Last_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Preferred_Last_Name.errors.required">Preferred Last Name is required</div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">

              <div class="col-md-12">

                <label class="col-form-label  col-md-12" for="login-Date_of_Incorporation">Date of Incorporation <code>*</code></label>
                <div class="input-group date" id="reservationdate" data-target-input="nearest">
                  <input type="text" formControlName="Date_of_Incorporation" data-target="#reservationdate" autocomplete="off"
                         id="Date_of_Incorporation" placeholder="Select Date of Incorporation"
                         class="form-control"
                         required
                         />
                  <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                    <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                  </div>
                  <div *ngIf="submitted && f.Date_of_Incorporation.errors" class="invalid-feedback">
                    <div *ngIf="f.Date_of_Incorporation.errors.required">Date of Incorporation is required</div>
                    <div *ngIf="f.Date_of_Incorporation.errors.pattern">Date of Incorporation must be a valid date in the format MM-DD-YYYY</div>
                    <div *ngIf="f.Date_of_Incorporation.errors.dateNotLessThanToday">Date of Incorporation cannot be less than today's date.</div>
                  </div>


                </div>


              </div>

            </div>
          </div>
          <!--<div class="col-sm-4">

    <div class="form-group">

      <label class="col-form-label  col-md-12" for="login-Years_in_Business">Years in Business<code>*</code></label>
      <input type="text" formControlName="Years_in_Business" class="form-control"
             [ngClass]="{'is-valid': f.Years_in_Business.valid, 'is-invalid' : submitted && f.Years_in_Business.valid}" placeholder="Enter Years in Business"
             appAiHint="Years in Business" [aiHintForm]="icdForm" />
      <div *ngIf="submitted && f.Years_in_Business.errors" class="invalid-feedback">
        <div *ngIf="f.Years_in_Business.errors.required">Years in Business is required</div>
        <div *ngIf="f.Years_in_Business.errors.pattern">Only numbers only allowed</div>
      </div>




    </div>
  </div>-->

          <div class="col-sm-4">

            <div class="form-group">

              <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N. # (Tax ID)/Business # <code>*</code></label>
              <input type="text" formControlName="Tax_ID" class="form-control"
                     placeholder="Enter  F.E.I.N. # (Tax ID)/Business" />
              <div *ngIf="submitted && f.Tax_ID.errors" class="invalid-feedback">
                <div *ngIf="f.Tax_ID.errors.required">F.E.I.N. # (Tax ID)/Business #  is required</div>
              </div>


            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

            <div class="form-group">

              <div class="col-md-12">
                <label class="form-label">State of Incorporation <code>*</code></label>
                <select formControlName="State_of_Incorporation" #selectEl class="form-control select2" [select2]="select2Options">
                  <option value="" disabled>Please Select</option>

                  <option *ngFor="let c of ddlUSStates" [ngValue]="c.value">{{ c.name }}</option>
                </select>
                <div *ngIf="submitted && f.State_of_Incorporation.errors" class="invalid-feedback">
                  <div *ngIf="f.State_of_Incorporation.errors.required">State of Incorporation is required</div>
                </div>


              </div>




            </div>
          </div>


          <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

            <div class="form-group">

              <div class="col-md-12">
                <label class="form-label">Province of Incorporation <code>*</code></label>
                <select formControlName="Provinence_of_Incorporation" class="form-control select2">
                  <option value="" disabled>Please Select</option>

                  <option *ngFor="let c of ddlCAProvinence" [ngValue]="c.value">{{ c.name }}</option>
                </select>
                <div *ngIf="submitted && f.Provinence_of_Incorporation.errors" class="invalid-feedback">
                  <div *ngIf="f.Provinence_of_Incorporation.errors.required">Province Incorporation is required</div>
                </div>


              </div>




            </div>
          </div>



        </div>


      </div>

    </div>



    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">Company Information (For Official Notices)</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">


          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Address1">Business Address 1<code>*</code></label>
              <input type="text" formControlName="Company_Address1" class="form-control"
                     [ngClass]="{'is-valid': f.Company_Address1.valid, 'is-invalid' : submitted && f.Company_Address1.valid}" placeholder="Enter Address 1"
                     appAiHint="Company Address 1" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_Address1.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Address1.errors.required">Address 1  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Address2">Address 2(e.g. Suite 100)</label>
              <input type="text" formControlName="Company_Address2" class="form-control"
                     [ngClass]="{'is-valid': f.Company_Address2.valid, 'is-invalid' : submitted && f.Company_Address2.valid}" placeholder="Enter Address 2 "
                     appAiHint="Company Address 2" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_Address2.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Address2.errors.required">Address 2  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_City">City <code>*</code></label>
              <input type="text" formControlName="Company_City" class="form-control"
                     [ngClass]="{'is-valid': f.Company_City.valid, 'is-invalid' : submitted && f.Company_City.valid}" placeholder="Enter  City"
                     appAiHint="Company City" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_City.errors" class="invalid-feedback">
                <div *ngIf="f.Company_City.errors.required">City is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Country">County <code>*</code></label>
              <input type="text" formControlName="Company_Country" class="form-control"
                     [ngClass]="{'is-valid': f.Company_Country.valid, 'is-invalid' : submitted && f.Company_Country.valid}" placeholder="Enter County"
                     appAiHint="Company County" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_Country.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Country.errors.required">County is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

            <div class="form-group">

              <div class="col-md-12">
                <label class="form-label">State  <code>*</code></label>
                <select formControlName="Company_State" #selectEl class="form-control select2"
                        [select2]="select2Options" [ngClass]="{ 'is-invalid': submitted && f.Company_State.errors }">
                  <option value="" disabled>Please Select</option>

                  <option *ngFor="let c of ddlUSStates" [ngValue]="c.value">{{ c.name }}</option>
                </select>
                <div *ngIf="submitted && f.Company_State.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_State.errors.required">State is required</div>
                </div>


              </div>




            </div>
          </div>


          <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

            <div class="form-group">

              <div class="col-md-12">
                <label class="form-label">Province <code>*</code></label>
                <select formControlName="Company_Province" class="form-control select2" [ngClass]="{ 'is-invalid': submitted && f.Company_Province.errors }">
                  <option value="" disabled>Please Select</option>

                  <option *ngFor="let c of ddlCAProvinence" [ngValue]="c.value">{{ c.name }}</option>
                </select>
                <div *ngIf="submitted && f.Company_Province.errors" class="invalid-feedback">
                  <div *ngIf="f.Company_Province.errors.required">Province  is required</div>
                </div>


              </div>




            </div>
          </div>



          <div class="col-sm-4">
            <div class="form-group">
              <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
              <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
              <input type="text" formControlName="Company_Postal_Code" class="form-control"
                     [ngClass]="{'is-valid': f.Company_Postal_Code.valid, 'is-invalid' : submitted && f.Company_Postal_Code.valid}" placeholder="Enter  postal Code (Zip)"
                     appAiHint="Company Postal Code" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_Postal_Code.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Postal_Code.errors.required">Postal Code  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Office_Phone">Office Phone <code>*</code></label>
              <input type="text" formControlName="Company_Office_Phone" class="form-control"
                     
                     placeholder="Enter  Office Phone"
                     appAiHint="Company Office Phone" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_Office_Phone.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Office_Phone.errors.required">Office Phone  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Company_Business_Email">Business Email <code>*</code></label>
              <input type="text" formControlName="Company_Business_Email" class="form-control"
                     [ngClass]="{'is-valid': f.Company_Business_Email.valid, 'is-invalid' : submitted && f.Company_Business_Email.valid}"
                     placeholder="Enter Business Email"
                     appAiHint="Company Business Email" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Company_Business_Email.errors" class="invalid-feedback">
                <div *ngIf="f.Company_Business_Email.errors.required">Business Email  is required</div>
              </div>

            </div>
          </div>

        </div>

        <!-- /.card-body -->
      </div>
    </div>


    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">Owner's Information</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_First_Name">Owner's Legal First Name <code>*</code></label>
              <input type="text" formControlName="Owner_First_Name" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_First_Name.valid, 'is-invalid' : submitted && f.Owner_First_Name.valid}"
                     placeholder="Enter  Owner Legal First Name"
                     appAiHint="Owner First Name" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_First_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_First_Name.errors.required">Owner First Name is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">



            <label class="col-form-label  col-md-12" for="login-Owner_Middle_Name">Owner's Legal Middle Name </label>

            <input type="text" formControlName="Owner_Middle_Name" class="form-control"
                   [ngClass]="{'is-valid':  f.Owner_Middle_Name.valid, 'is-invalid' :submitted && f.Owner_Middle_Name.valid}" placeholder="Enter Owner Legal Middle Name"
                   appAiHint="Owner Middle Name" [aiHintForm]="icdForm" />
            <div *ngIf="submitted && f.Owner_Middle_Name.errors" class="invalid-feedback">
              <div *ngIf="f.Owner_Middle_Name.errors.required">Middle Name is required</div>
            </div>


          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Last_Name">Owner's Legal Last Name <code>*</code></label>
              <input type="text" formControlName="Owner_Last_Name" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Last_Name.valid, 'is-invalid' : submitted && f.Owner_Last_Name.valid}"
                     placeholder="Enter Owner Legal Last Name "
                     appAiHint="Owner Last Name" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Last_Name.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Last_Name.errors.required">Owner Last Name  is required</div>
              </div>

            </div>
          </div>

          <!-- Feature 10 — secondary owner (read-only, shown when populated) -->
          <div class="col-sm-4" *ngIf="secondaryOwner">
            <div class="form-group">
              <label class="col-form-label col-md-12">Secondary Owner</label>
              <input type="text" class="form-control" [value]="secondaryOwner" disabled />
            </div>
          </div>


          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Perc">Ownership Percentage <code>*</code></label>
              <input type="text" formControlName="Owner_Perc" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Perc.valid, 'is-invalid' : submitted && f.Owner_Perc.valid}" placeholder="Enter  Ownership Percentage "
                     appAiHint="Owner Percentage" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Perc.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Perc.errors.required">Ownership Percentage  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Address1">Home Address 1<code>*</code></label>
              <input type="text" formControlName="Owner_Address1" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Address1.valid, 'is-invalid' : submitted && f.Owner_Address1.valid}" placeholder="Enter  Home Address 1"
                     appAiHint="Owner Address 1" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Address1.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Address1.errors.required">Home Address 1  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Address2">Address 2 (e.g. Suite 100)</label>
              <input type="text" formControlName="Owner_Address2" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Address2.valid, 'is-invalid' : submitted && f.Owner_Address2.valid}" placeholder="Enter Address 2 (e.g. Suite 100)"
                     appAiHint="Owner Address 2" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Address2.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Address2.errors.required">Address 2 (e.g. Suite 100)  is required</div>
              </div>

            </div>
          </div>



          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_City">City <code>*</code></label>
              <input type="text" formControlName="Owner_City" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_City.valid, 'is-invalid' : submitted && f.Owner_City.valid}" placeholder="Enter City"
                     appAiHint="Owner City" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_City.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_City.errors.required">City  is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4 hide" *ngIf="selectedCountry == 'US'">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Country">County <code>*</code></label>
              <input type="text" formControlName="Owner_Country" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Country.valid, 'is-invalid' : submitted && f.Owner_Country.valid}" placeholder="Enter County"
                     />
              <div *ngIf="submitted && f.Owner_Country.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Country.errors.required">Country is required</div>
              </div>

            </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

            <div class="form-group">

              <div class="col-md-12">
                <label class="form-label">State  <code>*</code></label>
                <select formControlName="Owner_State" #selectEl class="form-control select2"
                        [select2]="select2Options" [ngClass]="{ 'is-invalid': submitted && f.Owner_State.errors }">
                  <option value="" disabled>Please Select</option>

                  <option *ngFor="let c of ddlUSStates" [ngValue]="c.value">{{ c.name }}</option>
                </select>
                <div *ngIf="submitted && f.Owner_State.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_State.errors.required">State is required</div>
                </div>


              </div>




            </div>
          </div>


          <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

            <div class="form-group">

              <div class="col-md-12">
                <label class="form-label">Province <code>*</code></label>
                <select formControlName="Owner_Province" class="form-control select2" [ngClass]="{ 'is-invalid': submitted && f.Owner_Province.errors }">
                  <option value="" disabled>Please Select</option>

                  <option *ngFor="let c of ddlCAProvinence" [ngValue]="c.value">{{ c.name }}</option>
                </select>
                <div *ngIf="submitted && f.Owner_Province.errors" class="invalid-feedback">
                  <div *ngIf="f.Owner_Province.errors.required">Province  is required</div>
                </div>


              </div>




            </div>
          </div>


          <div class="col-sm-4">
            <div class="form-group">
              <label *ngIf="selectedCountry == 'Canada'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Postal Code (Zip) <code>*</code></label>
              <label *ngIf="selectedCountry == 'US'" class="col-form-label  col-md-12" for="login-Company_Postal_Code">Zip Code <code>*</code></label>
              <input type="text" formControlName="Owner_Postal_Code" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Postal_Code.valid, 'is-invalid' : submitted && f.Tax_ID.valid}" placeholder="Enter  Postal Code (Zip)"
                     appAiHint="Owner Postal Code" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Postal_Code.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Postal_Code.errors.required">Postal Code (Zip)  is required</div>
              </div>

            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Mobile_Phone">Mobile Phone <code>*</code></label>
              <input type="text" formControlName="Owner_Mobile_Phone" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Mobile_Phone.valid, 'is-invalid' : submitted && f.Owner_Mobile_Phone.valid}" placeholder="Enter  Mobile Phone "
                     appAiHint="Owner Mobile Phone" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Mobile_Phone.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Mobile_Phone.errors.required">Mobile Phone   is required</div>
              </div>

            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Owner_Home_Phone">Home Phone</label>
              <input type="text" formControlName="Owner_Home_Phone" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Home_Phone.valid, 'is-invalid' : submitted && f.Owner_Home_Phone.valid}" placeholder="Enter  Home Phone"
                     appAiHint="Owner Home Phone" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Home_Phone.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Home_Phone.errors.required">Home Phone  is required</div>
              </div>

            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Owner's Email <code>*</code></label>
              <input type="text" formControlName="Owner_Email" class="form-control"
                     [ngClass]="{'is-valid': f.Owner_Email.valid, 'is-invalid' : submitted && f.Owner_Email.valid}" placeholder="Enter  Owner's Email"
                     appAiHint="Owner Email" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.Owner_Email.errors" class="invalid-feedback">
                <div *ngIf="f.Owner_Email.errors.required">Owner's Email is required</div>
              </div>

            </div>
          </div>


          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label col-md-12" for="login-SSN-SIN">
                {{ isUS ? 'SSN' : 'SIN' }} <code>*</code>
              </label>
              <!-- Show masked value when not focused, and full value when editing -->
              <input type="text"
                     formControlName="SSN_SIN"
                     class="form-control"
                     [ngClass]="{'is-valid': f.SSN_SIN?.valid, 'is-invalid' : submitted && f.SSN_SIN?.invalid}"
                     placeholder="{{ isUS ? 'XXX-XX-XXXX' : 'XXX-XXX-XXX' }}"
                     
                     [value]="displayValue"
                     (input)="onInputChange($event.target.value)"
                     appAiHint="SSN / SIN" [aiHintForm]="icdForm" />
              <div *ngIf="submitted && f.SSN_SIN?.errors" class="invalid-feedback">
                <div *ngIf="f.SSN_SIN.errors.required">SSN/SIN is required</div>
                <div *ngIf="f.SSN_SIN.errors.pattern">Invalid {{ isUS ? 'SSN' : 'SIN' }} format</div>
              </div>
            </div>
          </div>

        </div>
        <!-- /.card-body -->
      </div>
    </div>

    <div class="card card-secondary">
      <div class="card-header">
        <h3 class="card-title">HUB Information</h3>
        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse">
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">

            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
              <div class="col-md-12">
                <input type="text" formControlName="HUB_Manager_Contact_Name" id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name" placeholder="Enter Hub Name" autocomplete="HUB_Manager_Contact_Name"
                       class="form-control"
                       appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Number">Hub Number <code>*</code></label>
              <div class="col-md-12">
                <input type="text" formControlName="HUB_Manager_Contact_Number" id="login-HUB_Manager_Contact_Number" name="HUB_Manager_Contact_Number" placeholder="Enter Hub Number"
                       autocomplete="current-Owner_Last_Name" class="form-control"
                       appAiHint="HUB Manager Contact Number" [aiHintForm]="icdForm" />

              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Email">Hub Email <code>*</code></label>
              <div class="col-md-12">
                <input type="text" formControlName="HUB_Manager_Contact_Email" id="login-HUB_Manager_Contact_Email" name="HUB_Manager_Contact_Email" placeholder="Enter Hub Email" autocomplete="current-HUB_Manager_Contact_Email"
                       class="form-control"
                       appAiHint="HUB Manager Contact Email" [aiHintForm]="icdForm" />

              </div>
            </div>
          </div>

        </div>

        <!-- /.card-body -->
      </div>
    </div>


    <div class="mb-3" *ngIf="btnDisplay">
      <h6>***</h6>If you have any questions about the information, please reach out to your Hub.

      <div class="custom-control custom-checkbox">
        I acknowledge that the information is accurate <code>*</code> &nbsp;&nbsp;&nbsp;&nbsp;

        <div class="col-sm-4">

          <div class="form-group">
            <div class="custom-control custom-switch  custom-switch-on-success">
              <input type="checkbox" formControlName="Acknowledge" class="custom-control-input" id="Acknowledge">
              <label class="custom-control-label" for="Acknowledge">Yes</label>
            </div>
          </div>

        </div>

        <div *ngIf="submitted && f.Acknowledge.errors" class="invalid-feedback">
          <div *ngIf="f.Acknowledge.errors.required">Acknowledge is required</div>
        </div>
      </div>



      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
      <button type="submit" class="btn btn-success float-right">
        {{isLoading ? 'Submit' : 'Submit'}}

      </button>


    </div>
  </form>

</div>


